import React from 'react';

const AIReportSkeleton = ({
  showMetrics = true,
  showSentiment = true,
  showObservations = true,
  metricsCount = 4,
  sentimentTitle = "User Sentiment",
  observationsTitle = "Key Observations",
  observationsCount = 3
}) => {
  return (
    <div style={{ color: '#ffffff' }}>
      <style>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        .skeleton-shimmer {
          background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 4px;
        }
      `}</style>

      {/* Metrics Grid Skeleton */}
      {showMetrics && (
        <div className="row mb-4">
          {Array.from({ length: metricsCount }).map((_, i) => (
            <div key={i} className="col-md-3 col-lg-3 mb-3">
              <div style={{
                backgroundColor: "rgba(23, 24, 33, 1)",
                border: "1px solid #374151",
                borderRadius: "12px",
                padding: "20px",
                height: "140px",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
                <div>
                  <div className="skeleton-shimmer" style={{ width: '60%', height: '12px', marginBottom: '12px' }} />
                  <div className="skeleton-shimmer" style={{ width: '80%', height: '32px' }} />
                </div>
                <div className="skeleton-shimmer" style={{ width: '40%', height: '14px' }} />
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Sentiment Section Skeleton */}
      {showSentiment && (
        <>
          <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px' }}>{sentimentTitle}</h3>
          <div className="row mb-4">
            <div className="col-md-4">
              <div style={{
                backgroundColor: "rgba(23, 24, 33, 1)",
                border: '1px solid #374151',
                borderRadius: '8px',
                padding: '16px',
                height: '184px',
                display: 'flex',
                alignItems: 'center',
                gap: '24px'
              }}>
                <div className="skeleton-shimmer" style={{ width: '120px', height: '120px', borderRadius: '50%' }} />
                <div style={{ flex: 1 }}>
                  <div className="skeleton-shimmer" style={{ width: '100%', height: '12px', marginBottom: '12px' }} />
                  <div className="skeleton-shimmer" style={{ width: '80%', height: '12px', marginBottom: '12px' }} />
                  <div className="skeleton-shimmer" style={{ width: '90%', height: '12px' }} />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div style={{
                backgroundColor: "rgba(23, 24, 33, 1)",
                border: '1px solid #374151',
                borderRadius: '8px',
                padding: '16px',
                height: '184px'
              }}>
                <div className="skeleton-shimmer" style={{ width: '50%', height: '18px', marginBottom: '16px' }} />
                <div className="skeleton-shimmer" style={{ width: '90%', height: '12px', marginBottom: '12px' }} />
                <div className="skeleton-shimmer" style={{ width: '85%', height: '12px', marginBottom: '12px' }} />
                <div className="skeleton-shimmer" style={{ width: '95%', height: '12px' }} />
              </div>
            </div>
            <div className="col-md-4">
              <div style={{
                backgroundColor: "rgba(23, 24, 33, 1)",
                border: '1px solid #374151',
                borderRadius: '8px',
                padding: '16px',
                height: '184px'
              }}>
                <div className="skeleton-shimmer" style={{ width: '50%', height: '18px', marginBottom: '16px' }} />
                <div className="skeleton-shimmer" style={{ width: '90%', height: '12px', marginBottom: '12px' }} />
                <div className="skeleton-shimmer" style={{ width: '85%', height: '12px', marginBottom: '12px' }} />
                <div className="skeleton-shimmer" style={{ width: '95%', height: '12px' }} />
              </div>
            </div>
          </div>
        </>
      )}

      {/* Observations Skeleton */}
      {showObservations && (
        <>
          <h3 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px' }}>{observationsTitle}</h3>
          {Array.from({ length: observationsCount }).map((_, i) => (
            <div key={i} style={{
              backgroundColor: '#1c1f2e',
              border: '1px solid #374151',
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '16px'
            }}>
              <div className="skeleton-shimmer" style={{ width: '40%', height: '18px', marginBottom: '12px' }} />
              <div className="skeleton-shimmer" style={{ width: '100%', height: '12px', marginBottom: '8px' }} />
              <div className="skeleton-shimmer" style={{ width: '90%', height: '12px' }} />
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default AIReportSkeleton;
